import type { Source } from './types';

// Imported through Vite rather than referenced from /public.
//
// This matters more than it looks. A file in /public is served at a fixed URL
// with no fingerprint, so the ONLY thing controlling whether a browser picks up
// a changed image is the Cache-Control header - and getting that wrong means a
// corrected logo stays invisible for as long as the max-age says. That is
// exactly what happened with this logo: an early build shipped a version whose
// white had been stripped by a background-removal script, and browsers that
// cached it kept showing black letters long after the real file was deployed.
//
// Importing instead makes Vite emit /assets/vtg-logo-<hash>.png. Change the
// image, get a new hash, get a new URL. The cache can never serve a stale one,
// and the bundle stays safely immutable.
import vtgLogo from './assets/vtg-logo.png';
import dattoIcon from './assets/datto.png';
import storagecraftIcon from './assets/storagecraft.png';
import msp360Icon from './assets/msp360.png';
import unitrendsIcon from './assets/unitrends.png';

/**
 * ShadowProtect and Image Manager are both StorageCraft products and share the
 * same mark - that matches how the original dashboard labelled them.
 */
/**
 * Every source has its own mark, taken from the vendor's own site. Sizing is
 * handled in CSS by HEIGHT within a fixed-width slot - see .nav-icon - because
 * these marks have very different aspect ratios and constraining width made the
 * wide ones render half the size of the square ones.
 */
const emailIcon =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
      'stroke="#708090" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/></svg>'
  );

export const SOURCE_ICON: Record<Source, string> = {
  datto: dattoIcon,
  sp: storagecraftIcon,
  sc: storagecraftIcon,
  msp: msp360Icon,
  unitrends: unitrendsIcon,
  email: emailIcon,
};

export const VTG_LOGO = vtgLogo;
